import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { ILogoutModalProps } from "../interface";

import { ICustomerAddress } from "@/api_framework/api_modals/Addresses";
import { IAddAddressBody } from "@/api_framework/api_modals/Users";
import { useAddAddressAPI } from "@/app/hooks/api_hooks/customer_profile/useAddAddressAPI";
import { useCustomerDetailsAPI } from "@/app/hooks/api_hooks/customer_profile/useCustomerDetailsAPI";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useAppDispatch, useAppSelector } from "@/app_redux/hooks/root_hook";
import {
  setCustomerAddresses,
  setCustomerPrimaryAddress,
} from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useEffect } from "react";
import { UseFormReturn, useForm } from "react-hook-form";
import NewAddressBlock from "../../auth_routes/CustomerProfile/AddCustomer/CustomerInfoForm/NewAddressBlock";

export interface IAddAddressModalState {
  userId: string;
  customerName: string;
}

const AddAddressModalContent: React.FC<{ formHook: UseFormReturn<ICustomerAddress, any> }> = ({ formHook }) => {
  return (
    <form onSubmit={formHook.handleSubmit(() => null)}>
      <NewAddressBlock formHook={formHook} />
    </form>
  );
};

const AddAddressModal: React.FC<ILogoutModalProps> = () => {
  const { userId, customerName }: IAddAddressModalState = useModalState("ADD_ADDRESS_MODAL");
  const { setInvisible } = useModalActions("ADD_ADDRESS_MODAL");
  const { newAddressId, execute: addAddress } = useAddAddressAPI();
  const dispatch = useAppDispatch();
  const fetchCustomerDetails = useCustomerDetailsAPI();


  

  const formHook = useForm<ICustomerAddress>({
    mode: "onChange",
    defaultValues: {
      label: "1",
    },
  });

  const onSubmit = (data: ICustomerAddress) => {
    if (data) {
      let payload: IAddAddressBody = {
        address_1: data.address_1 === "" ? null : data.address_1,
        label: data.label === "" ? null : data.label,
        user_id: userId,
      };

      if (data) {
        payload = {
          ...payload,
          address_2: data.address_2 === "" ? null : data.address_2,
          city: data.city === "" ? null : data.city,
          state: data.state === "" ? null : data.state,
          pincode: data.pincode === "" ? null : data.pincode,
          latitude: data?.latitude === "" ? null : data?.latitude,
          longitude: data?.longitude === "" ? null : data?.longitude,
        };
      }
      /* Clear all the loaded addresses */
      dispatch(
        setCustomerAddresses({
          addresses: [],
        }),
      );
      dispatch(setCustomerPrimaryAddress(null));
      addAddress(payload);
    }
  };

  useEffect(() => {
    if (newAddressId) {
      fetchCustomerDetails(userId);
      setInvisible();
    }
  }, [newAddressId]);

  return (
    <ModalPrompt
      modalId="ADD_ADDRESS_MODAL"
      backdropBlur={false}
      button={{
        primaryButtonText: "Add Address",
        primaryButtonClassname: "bg-black text-white hover:bg-gray-600 hover:text-white",
        secondaryButtonText: "Cancel",
        primaryCallback: () => {
          formHook.trigger().then((isValid) => {
            if (isValid) {
              onSubmit(formHook.getValues());
            }
          });
        },
        shouldHideOnClick: false,
      }}
      title={
        <span>
          Add new address for <span className="text-blue-600">{customerName}</span>
        </span>
      }
      content={<AddAddressModalContent formHook={formHook} />}
    />
  );
};

export default AddAddressModal;
